import { ConfigureTaskDrawerHeader } from './ConfigureTaskDrawer/ConfigureTaskDrawerHeader';
import { ConfigureWorkflowDrawerHeader } from './ConfigureWorkflowDrawer/ConfigureWorkflowDrawerHeader';
import { useFlowBuilder2PageStore } from '../../Store/useFlowBuilder2PageStore';
import { ConfigureComponentProps } from './ConfigureComponentDrawer/ConfigureComponentProps';
import { LayoutComponentEditorHeader } from './ConfigureComponentDrawer/LayoutComponentEditor/LayoutComponentEditorHeader';
import { BuilderTypeEnum } from '../../Store/FlowBuilder2PageStore.types';

export const ConfigureEditorDrawerHeader = () => {
  const hasActiveTask = useFlowBuilder2PageStore((s) => !!s.activeTaskId);
  const hasActiveComponent = useFlowBuilder2PageStore((s) => !!s.activeComponent);
  const isAdvancedEditorOpen = useFlowBuilder2PageStore(
    (s) => s.builderType === BuilderTypeEnum.AdvancedEditor,
  );

  if (isAdvancedEditorOpen) return <ConfigureWorkflowDrawerHeader />;

  switch (true) {
    case hasActiveComponent:
      return (
        <ConfigureComponentProps>
          {(props) => <LayoutComponentEditorHeader {...props} />}
        </ConfigureComponentProps>
      );
    case hasActiveTask:
      return <ConfigureTaskDrawerHeader />;
    default:
      return <ConfigureWorkflowDrawerHeader />;
  }
};
